import React from 'react'
import clsx from 'clsx'
import { Tab as HeadlessUITab } from '@headlessui/react'

import { Text } from '@wartek-id/text-v1'

type TCustomTabStepsProps = {
  selectedIndex?: number
  steps: {
    title: string
    content: React.ReactNode
  }[]
  onChange?: (index: number) => void
  panelClassName?: string
}
export const CustomTabSteps: React.FC<TCustomTabStepsProps> = ({
  selectedIndex = 0,
  steps,
  onChange = () => {},
  panelClassName,
}) => {
  return (
    <div>
      <HeadlessUITab.Group selectedIndex={selectedIndex} onChange={onChange}>
        <HeadlessUITab.List className="flex space-x-1">
          {steps.map(({ title }, key) => {
            return (
              <HeadlessUITab as={React.Fragment} key={key}>
                {({ selected }) => (
                  <button
                    className={clsx(
                      'text-white w-full rounded-md rounded-b-none p-6 group hover:bg-expressive-dark-blue',
                      selected
                        ? 'bg-expressive-dark-blue'
                        : 'bg-blue-5 text-black'
                    )}
                    style={{ flex: 1 }}
                  >
                    <Text
                      variant="heading-md"
                      className={clsx(
                        'group-hover:!text-white',
                        selected ? '!text-white' : '!text-blue-60'
                      )}
                    >
                      {title}
                    </Text>
                  </button>
                )}
              </HeadlessUITab>
            )
          })}
        </HeadlessUITab.List>
        <HeadlessUITab.Panels
          className={clsx('px-12 py-6 bg-white rounded-b-md', panelClassName)}
        >
          {steps.map(({ content }, key) => {
            return (
              <HeadlessUITab.Panel key={key}>{content}</HeadlessUITab.Panel>
            )
          })}
        </HeadlessUITab.Panels>
      </HeadlessUITab.Group>
    </div>
  )
}
